import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetProjectTypesQuery } from "../../../hooks/scientific/useGetProjectTypesQuery";
import { setProjectTypesData } from "../../../redux/slices/scientific/projectTypes";
import { routes } from "../../../routes";
import { updateProjectType } from "../../../services/scientific/projectType";
import { ProjectTypesType } from "../../../types/ScientificModule";
import { Key_projectTypes } from "../../../utils/constants";



const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
};

export const ProjectTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetProjectTypesQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<ProjectTypesType | null>(null);
  const mutationUpdate = useMutation(updateProjectType, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_projectTypes);
      toast.success('Tipo de Projeto atualizado com sucesso');
    },
    onError: () => {
      toast.error("Erro ao atualizar Tipo de Projeto.");
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createProjectType);
  };

  const handleEdit = (c: ProjectTypesType) => {
    dispatch(setProjectTypesData(c));
    navigate(routes.updateProjectType);
  };

  const handleDelete = (c: ProjectTypesType) => {
    c.status = false;
    mutationUpdate.mutateAsync(c);
  };

  const openDeleteDialog = (s: ProjectTypesType) => {
    setDeleteItem(s);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };

  const options = data?.items.map((c: ProjectTypesType) => [
    {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() =>
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            emptyMessage="Ainda não existem tipos de projecto registados."
          />
        }
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        description="O tipo de projecto deixará de estar disponível. Pretende continuar?"
        confirmLabel="Eliminar"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
};
